import { atom } from 'recoil';

export const toggleSspModels = atom({
    key: 'lambda-function-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
    },
});

export const isEnvDetailsLoading = atom({
    key: 'lambda-function-isEnvDetailsLoading',
    default: false,
});

export const orderId = atom({
    key: 'lambda-function-orderId',
    default: '',
});

export const sspSubmitOrder = atom({
    key: 'lambda-function-sspOrder',
    default: {
        // Application Section
        applicationName: null,
        appShortName: null,
        appProfile: null,
        entityDetails: null,
        sector: null,
        sectorDetails: null,
        department: null,
        appRegion: null,
        environment: null,
        landingZoneDetails: null,
        hCode: null,
        hCodeDetails: null,
        appOwner: null,
        appOwnerDetails: null,

        // Resource Section
        awsAccount: null,
        functionName: null,
        architecture: null,
        memory: '',
        timeout: '',
        appCodeRepository: 'uploadCodeRepository',
        adoProject: null,
        adoOrganization: null,
        repository: null,
        branch: '',
        handler: '',
        runtime: null,
        imageUrl: '',
        enableVpc: 'No',
        vpc: null,
        connectivityType: null,

        // Application Component Security Group Section
        componentName: null,
        componentNameDetails: null,

        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const costEstimateState = atom({
    key: 'lambda-function-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'lambda-function-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const isValidProvisioningForm = atom({
    key: 'lambda-function-isValidProvisioningForm',
    default: false,
});

export const isAppNameValid = atom({
    key: 'lambda-function-isAppNameValid',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 'lambda-function-isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'lambda-function-isAppShortNameExist',
    default: false,
});
